export const isPublishNotAllowed = (showSuccess, isValid, loginID, error) =>
  showSuccess || !isValid || !loginID || Boolean(error);
